import Swiper from "swiper/bundle";

export const marqueeSlider = (main, el) => {
    const select = document.querySelectorAll(main);
    select.forEach( e => {
        const selectSlider = e.querySelector(el);
        var swiper = new Swiper(selectSlider, {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            speed: 6000,
            allowTouchMove: false,
            autoplay: {
              delay: 1,
            },
        });
    })
}
